module.exports = __webpack_public_path__ + "static/img/2.ffa47b21.png";